if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

	constructor(){
		super();
		this.ajaxifyCartItems();
		// Initialize Okendo widgets on cart load
		setTimeout(() => {
			this.reinitializeOkendoWidgets();
		}, 500);
	}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

				// Handle subscription plan selection
				this.initSubscriptionPlans(item);

			})

		}

		initSubscriptionPlans(item){
			const subscriptionContainer = item.querySelector('[data-cart-item-subscription]');
			if (!subscriptionContainer) return;

			const radioButtons = subscriptionContainer.querySelectorAll('.cart-item__subscription-radio');
			const frequencySelect = subscriptionContainer.querySelector('.cart-item__subscription-select');
			const subscriptionOptions = subscriptionContainer.querySelectorAll('.cart-item__subscription-option');
			const frequencyDiv = subscriptionContainer.querySelector('.cart-item__subscription-frequency');

			radioButtons.forEach(radio => {
				radio.addEventListener('change', (e) => {
					const line = parseInt(radio.dataset.line);
					const itemKey = radio.dataset.itemKey;
					
					// Update active state for both options
					subscriptionOptions.forEach(option => {
						option.classList.remove('cart-item__subscription-option--active');
					});
					
					if (radio.value === 'subscribe') {
						// Show frequency dropdown and activate subscription option
						if (frequencyDiv) frequencyDiv.style.display = 'block';
						if (subscriptionOptions[0]) subscriptionOptions[0].classList.add('cart-item__subscription-option--active');
						
						// Fetch selling plans if not already loaded
						if (frequencySelect) {
							if (frequencySelect.options.length <= 1 && frequencySelect.options[0].value === '') {
								this.fetchSellingPlans(item, line, frequencySelect);
							} else if (frequencySelect.value && frequencySelect.value !== '') {
								// If a plan is already selected, update cart
								this.updateCartSellingPlan(line, frequencySelect.value);
							}
						}
					} else {
						// Hide frequency dropdown and activate one-time option
						if (frequencyDiv) frequencyDiv.style.display = 'none';
						if (subscriptionOptions[1]) subscriptionOptions[1].classList.add('cart-item__subscription-option--active');
						this.updateCartSellingPlan(line, '');
					}
				});
			});

			// Handle frequency selection change
			if (frequencySelect) {
				frequencySelect.addEventListener('change', (e) => {
					const line = parseInt(frequencySelect.dataset.line);
					if (e.target.value && e.target.value !== '') {
						this.updateCartSellingPlan(line, e.target.value);
					}
				});
			}
		}

		fetchSellingPlans(item, line, selectElement){
			// Selling plans are already populated in Liquid, so we just need to show the dropdown
			// If the select only has the placeholder option, we might need to fetch plans
			// For now, the plans should already be in the dropdown from Liquid
			if (selectElement && selectElement.options.length <= 1 && selectElement.options[0].value === '') {
				// If no plans are loaded, try to fetch them
				const productId = item.dataset.productId;
				if (productId) {
					fetch(`/products/${productId}.js`)
						.then(response => response.json())
						.then(product => {
							if (product.selling_plan_groups && product.selling_plan_groups.length > 0) {
								selectElement.innerHTML = '<option value="">Select frequency...</option>';
								product.selling_plan_groups.forEach(group => {
									if (group.selling_plans) {
										group.selling_plans.forEach(plan => {
											const option = document.createElement('option');
											option.value = plan.id;
											option.textContent = plan.name;
											selectElement.appendChild(option);
										});
									}
								});
							}
						})
						.catch(err => console.error('Error fetching selling plans:', err));
				}
			}
		}

		updateCartSellingPlan(line, sellingPlanId){
			this.form.classList.add('processing');
			
			const body = JSON.stringify({
				line: line,
				selling_plan: sellingPlanId || null
			});

			fetch(KROWN.settings.routes.cart_change_url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
				body
			})
			.then(response => response.json())
			.then(response => {
				return fetch('?section_id=helper-cart');
			})
			.then(response => response.text())
			.then(text => {
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();

				document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
				});
				document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
					elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
				});

				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
				
				// Re-initialize Okendo widgets after cart update
				this.reinitializeOkendoWidgets();
				
				const event = new Event('cart-updated');
				this.dispatchEvent(event);
			})
			.catch(e => {
				console.log(e);
				let alert = document.createElement('span');
				alert.classList.add('alert', 'alert--error');
				alert.textContent = KROWN.settings.locales.cart_general_error || 'Error updating subscription';
				this.form.prepend(alert);
			})
			.finally(() => {
				this.form.classList.remove('processing');
			});
		}

		reinitializeOkendoWidgets(){
			// Re-initialize Okendo star rating widgets after cart update
			const ratingWidgets = this.querySelectorAll('[data-oke-star-rating], [data-oke-reviews-product-id]');
			if (ratingWidgets.length > 0) {
				// Method 1: Try Okendo Widgets API if available
				if (typeof window.Okendo !== 'undefined') {
					// Try StarRating widget
					if (window.Okendo.Widgets && window.Okendo.Widgets.StarRating) {
						ratingWidgets.forEach(widget => {
							const productId = widget.getAttribute('data-oke-star-rating') || widget.getAttribute('data-oke-reviews-product-id');
							if (productId) {
								try {
									window.Okendo.Widgets.StarRating.render({
										target: widget,
										productId: productId
									});
								} catch(e) {
									console.log('Okendo StarRating widget render error:', e);
								}
							}
						});
					}
					// Try initWidgets method
					if (typeof window.Okendo.initWidgets === 'function') {
						setTimeout(() => {
							try {
								window.Okendo.initWidgets();
							} catch(e) {
								console.log('Okendo initWidgets error:', e);
							}
						}, 200);
					}
				}
				// Method 2: Trigger DOMContentLoaded-like event for Okendo to re-scan
				setTimeout(() => {
					if (typeof window.dispatchEvent !== 'undefined') {
						const event = new CustomEvent('okendo:reinitialize');
						window.dispatchEvent(event);
					}
					// Also try triggering a mutation observer by adding/removing a class
					ratingWidgets.forEach(widget => {
						widget.classList.add('oke-widget-trigger');
						setTimeout(() => {
							widget.classList.remove('oke-widget-trigger');
						}, 50);
					});
				}, 100);
			}
		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
					
					// Re-initialize Okendo widgets after cart update
					this.reinitializeOkendoWidgets();
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			
			// Re-initialize Okendo widgets after cart refresh
			const cartForm = document.getElementById('AjaxCartForm');
			if (cartForm && typeof cartForm.reinitializeOkendoWidgets === 'function') {
				cartForm.reinitializeOkendoWidgets();
			}
			
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {
				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');

				this.loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add('processing');
						if (this.discountCodes) {
							this.discountCodes.classList.add('processing');
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.handleSuccess();
									} else {
										this.handleError();
									}
								} else {
									this.handleError();
								}
							})
							.catch(error => {
								this.handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			handleSuccess(){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
						this.cartSubtotal.innerHTML = cartSubtotalInnerHTML;
						this.cartSubtotal.classList.remove('processing');
						this.cartDiscountError.innerHTML = '';
						if ( sectionInnerHTML.querySelector('[data-js-discount-codes]') ) {
							this.discountCodes.innerHTML = sectionInnerHTML.querySelector('[data-js-discount-codes]').innerHTML;
							this.discountCodes.classList.remove('processing');
							this.loadDiscountButtons();
						}
						this.input.value = '';
					})
			}

			loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains('enabled') ) {
						elm.classList.add('enabled');
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add('processing');
							if (this.discountCodes) {
								this.discountCodes.classList.add('processing');
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			handleError(){
				this.cartSubtotal.classList.remove('processing');
				if (this.discountCodes) {
					this.discountCodes.classList.remove('processing');
				}
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}